import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import get from "lodash/get";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import Add from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";
import { instance, instanceMultipart } from "Actions/AxiosInstance";
import { withSnackbar } from "notistack";

import { ValidateList, ValidateSearchDropdown } from "Utils/Validation";
import { getFormattedImageLink, isAlphaNumeric } from "Utils";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setOnbConfig } from "Module/Accounts/Onboarding/actions";
import { updateAuthentication } from "Actions/AuthenticationAction";

class company_profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: {
        countryid: "",
        currency: "",
        countrytimezoneid: "",
        callingcode: "",
        financialcycleid: 4,
        weekstartid: "",
        leavecycleid: 1,
        dateformatid: "",
        logo: "",
        subdomain: "",
      },
      reqList: {
        countryid: "",
        countrytimezoneid: "",
        financialcycleid: 4,
        weekstartid: "",
        leavecycleid: 1,
        dateformatid: "",
      },
      fields: {
        subdomain: "",
      },
      errors: {},
      helperText: {},
      currency: [],
      country: [],
      selectedCountry: {},
      timezones: [],
      selectedTimeZone: {},
      financialCycles: [],
      selectedfinCycle: { displayname: "April", displayvalue: "4" },
      leaveCycles: [],
      selectedleaveCycle: { displayname: "January", displayvalue: "1" },
      dateFormats: [],
      dates: [],
      selectedDateformat: {},
      weekStartList: [],
      selectedWeekStart: {},
      preFilled: false,
      isLeaveCycleBlank: true,
      isFYBlank: true,
      timeformat: "",
    };

    this.removeImg = this.removeImg.bind(this);
    this.setTimeFormat = this.setTimeFormat.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.GetSubDomain = this.GetSubDomain.bind(this);
  }

  componentWillMount() {
    this.GetCountry();
  }

  componentDidMount() {
    // if(!this.props.dashboard && this.props.stepcompleted > this.props.step){
    //   setTimeout(
    //     this.GetForm()
    //   ,1000);
    // }else if(this.props.dashboard){
    //   setTimeout(
    //     this.GetForm()
    //   ,1000);
    // }
    // window.scrollTo(0, 0);
    const id = this.props.onboarding.configStatus;
    this.GetAllSubscription(id);
    // this.GetCountry();
    // this.GetTimezone();
    this.GetDateFormat();
    this.GetWeekStart();

    this.GetSubDomain();

    // setTimeout(this.GetForm(), 1000);
  }

  GetCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
        this.GetTimezone();
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetTimezone() {
    instance
      .get("superuser/alltimezone")
      .then((result) => {
        const timezones = [];
        timezones.push(
          { displayname: "Select Timezone", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ timezones });
        this.GetDateFormat();
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetFinancialCycles() {
    instance
      .get("superuser/getmastercode/Months")
      .then((result) => {
        const financialCycles = [];
        financialCycles.push(
          { displayname: "Select Financial Cycle", displayvalue: "" },
          ...result.data.result,
        );
        // let list = this.state.list
        // list.financialcycleid = 4
        this.setState({ financialCycles });
        this.GetWeekStart();
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetLeaveCycles() {
    instance
      .get("superuser/getmastercode/Months")
      .then((result) => {
        const leaveCycles = [];
        leaveCycles.push(
          { displayname: "Select Leave Cycle", displayvalue: "" },
          ...result.data.result,
        );
        // let list = this.state.list
        // list.leavecycleid = 1
        this.setState({ leaveCycles });
        this.GetFinancialCycles();
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetDateFormat() {
    instance
      .get("superuser/getmastercode/DateFormat")
      .then((result) => {
        const dateFormats = [];
        dateFormats.push(
          { displayname: "Select Date Format", displayvalue: "" },
          ...result.data.result,
        );
        const dates = dateFormats.map((dt) => {
          const x = dt && dt.displayname.split("H");
          return {
            displayname: x[0],
            displayvalue: dt.displayvalue,
          };
        });
        const dates1 = getUnique(dates);

        this.setState({ dateFormats, dates: dates1 });
        this.GetLeaveCycles();
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetWeekStart() {
    instance
      .get("superuser/getmastercode/Week")
      .then((result) => {
        const weekStartList = [];
        weekStartList.push(
          { displayname: "Select Week Start", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ weekStartList });

        // if (
        //   !this.props.dashboard &&
        //   this.props.stepcompleted > this.props.step
        // ) {
        //   setTimeout(this.GetForm(), 100);
        // } else if (this.props.dashboard) {
        //   setTimeout(this.GetForm(), 100);
        // }
        // setTimeout(this.GetForm(), 100);
        setTimeout(() => {
          this.GetForm();
        }, 100);
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetForm() {
    console.log("datatattt", this.state);
    const URL = `account/globledefault/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const preFilled = result.data.result.length > 0;
        const data = result.data.result[0];
        let isLeaveCycleBlank = true;
        let isFYBlank = true;
        if (data.leavecycleid > 0) {
          isLeaveCycleBlank = false;
        }
        if (data.financialcycleid > 0) {
          isFYBlank = false;
        }

        const list = {
          countryid: data.countryid,
          countrytimezoneid: data.countrytimezoneid,
          financialcycleid: data.financialcycleid,
          leavecycleid: data.leavecycleid,
          weekstartid: data.weekstartid,
          dateformatid: data.dateformatid,
          currency: data.currency,
          logo: data.logo || this.props.logo,

          callingcode: data.callingcode, // CountryDetails.callingcode
        };
        const reqList = {
          countryid: data.countryid,
          countrytimezoneid: data.countrytimezoneid,
          financialcycleid: data.financialcycleid,
          weekstartid: data.weekstartid,
          leavecycleid: data.leavecycleid,
          dateformatid: data.dateformatid,
        };
        const selectedCountry =
          this.state.country &&
          this.state.country.find((x) => x.displayvalue == list.countryid);
        const selectedTimeZone =
          this.state.timezones &&
          this.state.timezones.find(
            (x) => x.displayvalue == list.countrytimezoneid,
          );

        console.log("selectedTimeZone: ", selectedTimeZone);
        const selectedfinCycle =
          this.state.financialCycles &&
          this.state.financialCycles.find(
            (x) => x.displayvalue == list.financialcycleid,
          );
        const selectedleaveCycle =
          this.state.leaveCycles &&
          this.state.leaveCycles.find(
            (x) => x.displayvalue == list.leavecycleid,
          );
        const selectedDateformat =
          this.state.dateFormats &&
          this.state.dateFormats.find(
            (x) => x.displayvalue == list.dateformatid,
          );
        console.log("selectedDateformat: ", selectedDateformat);

        let timeformat = "";
        if (selectedDateformat) {
          selectedDateformat.displayname.includes("12")
            ? (timeformat = "12")
            : (timeformat = "24");
          selectedDateformat.displayname =
            selectedDateformat.displayname.split(" ")[0];
        }
        const selectedWeekStart =
          this.state.weekStartList &&
          this.state.weekStartList.find(
            (x) => x.displayvalue == list.weekstartid,
          );

        console.log("selectedWeekStart: ", selectedWeekStart);

        this.setState({
          timeformat,
          selectedCountry,
          preFilled,
          isLeaveCycleBlank,
          isFYBlank,
          selectedTimeZone,
          selectedfinCycle,
          selectedWeekStart,
          selectedleaveCycle,
          selectedDateformat,
          list,
          reqList,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleChange(name, e) {
    const { list } = this.state;
    list[name] = e;
    this.setState({
      list,
    });
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    // if (!ValidateDropdown(this.state)) {
    //     formIsValid = false;
    // }
    return formIsValid;
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem.displayvalue;
    // this.props.SetMarkdown(HtField);
    switch (name) {
      case "countryid":
        let currency;
        let callingcode;
        if (selectedItem != "") {
          currency = this.state.list.currency = selectedItem.currency
            ? selectedItem.currency
            : "";
          callingcode = this.state.list.callingcode = selectedItem.callingcode
            ? selectedItem.callingcode
            : "";
          this.setState({
            currency,
            callingcode,
            selectedCountry: selectedItem,
          });
        } else {
          currency = this.state.list.currency = "";
          callingcode = this.state.list.callingcode = "";
          this.setState({ currency, callingcode });
        }
        break;
      case "countrytimezoneid":
        this.setState({ selectedTimeZone: selectedItem });
        break;
      case "financialcycleid":
        this.setState({ selectedfinCycle: selectedItem });
        break;
      case "leavecycleid":
        this.setState({ selectedleaveCycle: selectedItem });
        break;
      case "dateformatid":
        this.setState({ selectedDateformat: selectedItem });
        break;
      case "weekstartid":
        this.setState({ selectedWeekStart: selectedItem });
    }

    this.setState({ list });

    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  setTimeFormat(time) {
    if (
      this.state.selectedDateformat &&
      this.state.selectedDateformat.displayvalue
    ) {
      const date = this.state.selectedDateformat;
      const dates = this.state.dateFormats.filter((dt) =>
        dt.displayname.includes(date.displayname),
      );
      let selectedDateformat = "";
      dates &&
        dates.forEach((dt) => {
          if (time == 12 && dt.displayname.includes(time)) {
            selectedDateformat = dt;
            if (selectedDateformat) {
              selectedDateformat.displayname = date.displayname;
            }
          } else if (time == 24 && dt.displayname.includes(time)) {
            selectedDateformat = dt;
            if (selectedDateformat) {
              selectedDateformat.displayname = date.displayname;
            }
          }
        });
      const { list } = this.state;
      list.dateformatid = selectedDateformat.displayvalue;
      console.log("list", list);
      if (selectedDateformat != "") {
        list.dateformatid = selectedDateformat.displayvalue;
        console.log("list", list);
        this.setState({
          selectedDateformat,
          timeformat: time,
          list,
        });
      } else {
        list.dateformatid = date.displayvalue;
        console.log("list", list);
        this.setState({
          selectedDateformat: date,
          timeformat: time,
          list,
        });
      }
    } else {
      this.props.enqueueSnackbar("Please select date format", {
        variant: "error",
      });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  getFiles1(IMG, imgname, HtField, files) {
    const file = files[0];
    const formData = new FormData();
    // if (get(this.props, "AuthenticationAction.IsFulfilled", "")) {
    //   formData.append("file", file);
    // } else {
    //   formData.append("file", file);
    // }
    formData.append("file", file);

    if (files.length == 0) {
      this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
        variant: "error",
      });
      return false;
    }
    instanceMultipart
      .post(
        `/subscription/uploaddefault/${get(
          this.props,
          "SubscriptionInfo.SubscriptionData.subscriptionid",
          "",
        )}/${get(
          this.props,
          "SubscriptionInfo.SubscriptionData.subscriptionid",
          "",
        )}/0`,
        formData,
      )
      .then((resp) => {
        const { list } = this.state;
        list[imgname] = resp.data.result[0].imagepath;
        this.setState({ list });
      });
  }

  onCancel(imgname) {
    const { list } = this.state;
    list[imgname] = "";
    this.setState({ list });
  }

  removeImg(imgname) {
    console.log("imgname: ", imgname);
    const { list } = this.state;
    list[imgname] = "";
    this.setState({ list });
  }

  validateAction(name, type) {
    console.log("name: ", name);

    const { list } = this.state;
    let formIsValid = true;
    const errors = this.state;
    if (list[name]) {
      const img = list[name].split(";");
      const imgname = img[0];
      let idxDot;
      let extFile;
      idxDot = imgname.lastIndexOf("/") + 1;
      extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
      if (
        !(
          extFile == "png" ||
          extFile == "jpg" ||
          extFile == "jpeg" ||
          extFile == "svg+xml"
        )
      ) {
        formIsValid = false;
        errors[name] = true;
        console.log("name1: ", name);
        this.setState({ errors });
      } else {
        errors[name] = false;
        console.log("name2: ", name);
        this.setState({ errors });
      }
    }
    console.log("name3: ", formIsValid);
    return formIsValid;
  }

  OnFormSubmit() {
    if (this.state.list.logo == "" && !this.state.list.logo) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else if (this.state.timeformat == "") {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      this.setState({ CommonError: "" });
      const data = {
        logo: this.state.list.logo,

        countryid: this.state.list.countryid,
        countrytimezoneid: this.state.list.countrytimezoneid,
        financialcycleid: this.state.list.financialcycleid,
        weekstartid: this.state.list.weekstartid,
        leavecycleid: this.state.list.leavecycleid,
        dateformatid: this.state.list.dateformatid,
        // stepcompleted: this.props.dashboard
        //   ? this.props.currentsubscription.stepcompleted
        //   : this.props.stepcompleted > this.props.step
        //   ? this.props.stepcompleted
        //   : this.props.step,
      };
      console.log("data", data);
      const URL = `account/globledefault/${get(
        this.props,
        "SubscriptionInfo.SubscriptionData.subscriptionid",
        "",
      )}`;
      instance
        .put(URL, data)
        .then((result) => {
          // if (this.props.dashboard) {
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          // console.log("hh11");
          // if (!this.props.dashboard) {
          //   console.log("hh");
          //   this.props.setLogo(data.logo);
          //   this.props.updateStep(1);
          // }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  GetAllSubscription(id) {
    instance
      .get(`account/allsubscription`)
      .then((result) => {
        const subscriptionsData = [
          ...result.data.result.Active,
          ...result.data.result.InActive,
        ];
        const currentsubscription = subscriptionsData.find(
          (data) => data.subscriptionid == id,
        );

        if (currentsubscription.issetupdone) {
          const employeeLink = `${window.location.origin}/dashboard`;
          setTimeout(() => {
            window.open(employeeLink, "_self");
          }, 100);
        } else {
          this.setState({
            currentsubscription,
            stepcompleted: currentsubscription.stepcompleted,
            logo: currentsubscription.logopath,
            step: currentsubscription.stepcompleted,
            dr: true,
          });
        }
      })
      .catch((error) => {
        // console.log('error: ', error);
      });
  }

  GetSubDomain() {
    const URL = `account/branddetail/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result[0];
        const fields = {
          subscriptionname: get(data, "subscriptionname", ""),
          subdomain: get(data, "subdomain", ""),
          // sendername: get(data, "sendername", ""),
          // senderemail: get(data, "senderemail", ""),
          // replytoemail: get(data, "replytoemail", ""),
          // sendersignature: get(data, "sendersignature", ""),
          headertext: get(data, "headertext", ""),
          subheadertext: get(data, "subheadertext", ""),
          logo: get(data, "logo", ""),
          favicon: get(data, "favicon", ""),
          bgimage: get(data, "bgimage", ""),
          // incorporationdate: get(data, "incorporationdate", "")
        };
        const reqFields = {
          subscriptionname: get(data, "subscriptionname", ""),
          subdomain: get(data, "subdomain", ""),
          incorporationdate: get(data, "incorporationdate", ""),
        };
        const reqList = {
          subscriptionname: data.subscriptionname,
        };

        // let subscriptiontypeid = this.state.subscriptionTypeList &&
        //   this.state.subscriptionTypeList.find(
        //   x => x.displayvalue == data.subscriptiontypeid
        // );
        // let list = this.state.list;
        // list.subscriptiontypeid = subscriptiontypeid || "";
        this.setState({ fields, reqFields, reqList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <p className="large-text-dark-secondary t-bold margin-bottom-40">
          Global defaults
        </p>

        <Grid container>
          <Grid item sm={12} md={6}>
            <div className="margin-bottom-16">
              <p className="input-label">Your subdomain</p>
              <div className="display-flex">
                <p className="large-text-dark margin-right-8">https://</p>
                <TextField
                  className="margin-top-0"
                  style={{ width: "90%", background: "#f7f8f8" }}
                  id="outlined-bare"
                  palceholder="Enter subdomain"
                  // onChange={this.OnFieldChange.bind(
                  //   this,
                  //   "subdomain",
                  //   "text",
                  // )}
                  onChange={(e) =>
                    this.handleChange("subdomain", e.target.value)
                  }
                  // onBlur={this.setSubdmain.bind(this)}
                  value={this.state.fields.subdomain}
                  error={
                    this.state.fields.subdomain &&
                    !isAlphaNumeric(this.state.fields.subdomain)
                  }
                  type="text"
                  margin="normal"
                  variant="outlined"
                  // disabled={this.props.currentsubscription.issetupdone}
                  disabled={true}
                />
                <p className="large-text-dark margin-left-8">.sumhr.io</p>
              </div>
              <div>
                {this.state.errors.subdomain ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErSubdomainURL"
                      defaultMessage="can not be empty"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className="display-flex" style={{ justifyContent: "center" }}>
              {!this.state.list.logo && (
                <span
                  className="add-attachment"
                  style={{ width: 180, height: 60 }}
                >
                  <Dropzone
                    onDragEnter={this.validateAction.bind(this, "logo", "img")}
                    onDrop={this.getFiles1.bind(
                      this,
                      "logo",
                      "logo",
                      "HtCompanyLogo",
                    )}
                    onFileDialogCancel={this.onCancel.bind(this, "logo")}
                    multiple={false}
                    accept="image/gif, image/jpeg, image/png, image/jpg"
                    // style={thumb}
                    maxSize={2000000}
                    label=" Drag & upload"
                    // className="text-align-center"
                    style={{
                      marginTop: 2,
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    <Add
                      className="add-attachement-icon"
                      style={{ marginLeft: 0, marginTop: 0 }}
                    />
                    <div style={{ fontSize: 12 }}>Upload company logo</div>
                  </Dropzone>
                </span>
              )}

              {this.state.list.logo && (
                <div
                  style={{
                    padding: 2,
                    borderRadius: 5,
                    border: "1px solid #cdcdcd",
                    height: 60,
                    width: 180,
                  }}
                >
                  <img
                    className="floatleft"
                    style={{ objectFit: "contain" }}
                    src={
                      this.state.list.logo &&
                      getFormattedImageLink(this.state.list.logo)
                    }
                    height="60"
                    width="148"
                  />
                  <CloseIcon
                    style={{ backgroundColor: "#ffff", height: 16 }}
                    // lassName="remove-img-icon"
                    onClick={() => this.removeImg("logo")}
                  />
                </div>
              )}
   
            </div>
            <p className="input-label" style={{paddingLeft: 8}}>
              Note: Upload photo with max size 2 MB for optimum results.
              (Supports .gif, .jpeg, .jpg and .png file types)
            </p>
          </Grid>
        </Grid>
        <div className="dashed-divider1"></div>
        <Grid container spacing={4} className="margin-top-8">
          <Grid item sm={12} md={6}>
            <div className="margin-bottom-16">
              <p className="input-label">Select country</p>
              <Select
                id="Country Name"
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "countryid",
                  "HtCompanysHQCountry",
                )}
                options={this.state.country}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedCountry}
                placeholder="Select Country"
              />
              <div>
                {this.state.errors.countryid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    <FormattedMessage
                      id="Erpleaseselectcountry"
                      defaultMessage="please select country time zone"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">
                <label htmlFor="Timezone">Select Timezone</label>
              </p>
              <Select
                id="Timezone"
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "countrytimezoneid",
                  "HtTimezone",
                )}
                options={this.state.timezones}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedTimeZone}
                placeholder="Select Time Zone"
              />
              <div>
                {this.state.errors.countrytimezoneid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    <FormattedMessage
                      id="ErTimezone"
                      defaultMessage="please select country time zone"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">
                <label htmlFor="Leave Cycle">
                  Select Leave Cycle (Start month)
                </label>
              </p>

              <Select
                id="Leave Cycle"
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "leavecycleid",
                  "HtLeaveCycle",
                )}
                options={this.state.leaveCycles}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedleaveCycle}
                placeholder="Select Leave Cycles"
                // defaultInputValue="January"
                isDisabled={!this.state.isLeaveCycleBlank}
              />
              <div>
                {this.state.errors.leavecycleid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    <FormattedMessage
                      id="ErLeaveCycle"
                      defaultMessage="please select leavecycle"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">Select preferred date format</p>
              <Select
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "dateformatid",
                  "HtDateFormat",
                )}
                options={this.state.dates}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedDateformat}
                placeholder="Select Date format"
              />
              <div>
                {this.state.errors.dateformatid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    {" "}
                    <FormattedMessage
                      id="ErDateFormat"
                      defaultMessage="please select dateformat"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <Grid
              container
              className="form-flexible-container margin-bottom-16"
            >
              <Grid item md={6} lg={9} className="display-flex">
                <div
                  style={{
                    width: "40%",
                    display: "inline-block",
                    marginTop: 18,
                  }}
                >
                  <p className="input-label">
                    <label htmlFor="Currency">Currency</label>
                  </p>
                  <span id="Currency" style={{ height: 20, display: "block" }}>
                    {this.state.selectedCountry
                      ? this.state.selectedCountry.currency
                      : "-"}
                  </span>
                </div>
                <div
                  style={{
                    marginTop: 18,
                    width: "45%",
                    display: "inline-block",
                  }}
                >
                  <p className="input-label">
                    <label htmlFor="Calling Code">Calling Code</label>
                  </p>
                  <span
                    id="Calling Code"
                    style={{ height: 20, display: "block" }}
                  >
                    {this.state.selectedCountry &&
                      this.state.selectedCountry.callingcode}
                  </span>
                </div>
              </Grid>
              <Grid item md={6} lg={3}></Grid>
            </Grid>
            <div className="margin-bottom-16">
              <p className="input-label">When does your week start?</p>

              <Select
                id="Company Week Start"
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "weekstartid",
                  "HtWeekStart",
                )}
                options={this.state.weekStartList}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedWeekStart}
                placeholder="Select Week Start"
              />
              <div>
                {this.state.errors.weekstartid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    <FormattedMessage
                      id="ErWeekStart"
                      defaultMessage="please select week start"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">
                When does your financial year start?
              </p>

              <Select
                id="Country City"
                onChange={this.UpdateSelectedDropdownItem.bind(
                  this,
                  "financialcycleid",
                  "HtFinancialCycle",
                )}
                options={this.state.financialCycles}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedfinCycle}
                placeholder="Select Financial Cycles"
                isDisabled={!this.state.isFYBlank}
              />
              <div>
                {this.state.errors.financialcycleid ? (
                  <span className="caption-error" style={{ lineHeight: 3 }}>
                    <FormattedMessage
                      id="ErFinancialCycles"
                      defaultMessage="please select financial cycle"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="margin-bottom-16">
              <p className="input-label">Select preferred time format</p>
              <Chip
                // className="margin4 t-12"
                label="12 hours"
                clickable
                className={
                  this.state.timeformat == 12
                    ? "selected-chip margin-right-8"
                    : "not-selected-chip margin-right-8"
                }
                onClick={() => this.setTimeFormat("12")}
                deleteIcon={<DoneIcon />}
                variant="outlined"
              />
              <Chip
                // className="margin4 t-12"
                label="24 hours"
                clickable
                className={
                  this.state.timeformat == 24
                    ? "selected-chip  margin-right-8"
                    : "not-selected-chip margin-right-8"
                }
                onClick={() => this.setTimeFormat("24")}
                deleteIcon={<DoneIcon />}
                variant="outlined"
              />
            </div>
          </Grid>
        </Grid>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div className="floatright" style={{ marginRight: 72 }}>
            <div>
              <Button
                variant="contained"
                className="btn btn-primary-md-blue"
                color="primary"
                onClick={this.OnFormSubmit.bind(this)}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="clearfloat"></div>
        </div>
      </div>
    );
  }
}

function getUnique(arr) {
  const comp = "displayname";
  const unique = arr
    .map((e) => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  onboarding: state.Onboarding,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication,
      setOnbConfig,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(company_profile));
